module.exports = "/images/ef56b52183a3c97463fa7a063f062467.gif";